(() => {
  const bar = document.querySelector('.rise-sticky-cart');
  const info = document.querySelector('product-info[id^="MainProduct-"]');
  if (!bar || !info) return;
  const button = bar.querySelector('button');
  const error = bar.querySelector('.rise-sticky-cart__error');
  let original;
  let inView = false;
  const mobile = window.matchMedia('(max-width: 766px)');
  const intersection = new IntersectionObserver(([entry]) => {
    inView = entry.isIntersecting;
    sync();
  }, { threshold: 0 });
  function sync() {
    const current = info.querySelector('product-form button[name="add"]');
    if (current !== original) {
      if (original) intersection.unobserve(original);
      original = current;
      inView = false;
      if (original) intersection.observe(original);
    }
    bar.hidden = !original || inView || (mobile.matches && window.scrollY < 300);
    document.body.classList.toggle('rise-has-sticky-cart', !!original);
    if (!original) return;
    const busy = original.getAttribute('aria-disabled') === 'true';
    button.disabled = original.disabled || busy;
    button.textContent = original.querySelector('span')?.textContent.trim() || original.textContent.trim();
    button.setAttribute('aria-busy', String(busy));
    const message = info.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message');
    error.textContent = message?.textContent.trim() || '';
    error.hidden = !error.textContent;
  }
  button.addEventListener('click', () => {
    if (!original || button.disabled) return;
    const form = original.form;
    if (form && !form.reportValidity()) {
      form.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    original.click();
    sync();
  });
  new MutationObserver(sync).observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'hidden'] });
  let scrollFrame;
  window.addEventListener('scroll', () => {
    if (scrollFrame) return;
    scrollFrame = requestAnimationFrame(() => {
      scrollFrame = null;
      sync();
    });
  }, { passive: true });
  mobile.addEventListener('change', sync);
  sync();
})();
